export default __webpack_public_path__ + "static/media/icon_menu_changelog_hover.5a6653ca.svg";